<script lang="ts" setup>
import UserAvatar from "@/components/UserAvatar.vue";
import { timeAgo } from "@/modules/common";
import { useDefaultAvatar } from "@/use/common";
import { NotificationTypeEnum } from "@/enums/notificationEnum";

// Props & Emit
interface MessageItem {
  avatarUrl?: string;
  type: 2 | NotificationTypeEnum;
  name?: string;
  message?: string;
  time: string;
  unread?: number;
  rows?: number;
}

withDefaults(defineProps<MessageItem>(), {
  avatarUrl: useDefaultAvatar(),
  name: "",
  message: "",
  unread: 0,
  rows: 1,
});
</script>
<template>
  <div
    :class="{ 'chat-message': type === 2, 'interaction-message': type !== 2 }"
    class="grid grid-cols-[auto_1fr_auto] p-2 border-b justify-between"
  >
    <div class="indicator">
      <span
        v-if="unread && unread > 0"
        class="indicator-item badge badge-primary badge-sm"
        >{{ unread }}</span
      >
      <user-avatar
        :avatar-url="avatarUrl"
        class="h-10 w-[30px] shrink-0 mr-2"
      />
    </div>
    <div class="flex flex-col flex-grow overflow-hidden">
      <div class="flex justify-between items-center">
        <div class="text msg-name">
          {{ name }}
        </div>
        <div class="text-xs text-base-content/50 shrink-0">
          {{ timeAgo(time) }}
        </div>
      </div>
      <div class="line-clamp-1" v-html="message" />
    </div>
  </div>
</template>
<style scoped>
.chat-message .msg-content {
  @apply text-base-content/50;
}

.interaction-message .msg-name {
  @apply text-base-content;
}
</style>
